import React from 'react';
import { ServicesContext } from '~/services';
import { ReminderFeed } from '~/components/Reminders';

interface PatientRemindersProps {
    patientId: number;
    patient: PatientType;
    setTabValue: (x: number) => void;
}
export function PatientReminders({ patientId, patient, setTabValue }: PatientRemindersProps) {
    const servicesContext = React.useContext(ServicesContext);
    async function performAdd(description: string, dueDate: string) {
        await servicesContext.patient.addReminder(
            { patient: { id: patientId } },
            description,
            dueDate
        );
    }
    return (
        <ReminderFeed
            performAdd={performAdd}
            loadEntity={`patient.id=${patientId}`}
            patient={patient}
            setTabValue={setTabValue}
            enableOpenModal
        />
    );
}
